import { PageId } from 'constants/pages'

export const enum PageIdIntl3 {
  ANALYZING = PageId.ANALYZING_INTL_3,
  START = PageId.START_INTL_3,
  PUZZLES_ENJOYMENT = PageId.PUZZLES_ENJOYMENT_INTL_3,
  APPLY_KNOWLEDGE_REAL_LIFE = PageId.APPLY_KNOWLEDGE_REAL_LIFE_INTL_3,
  NOTICE_PATTERNS = PageId.NOTICE_PATTERNS_INTL_3,
  STAY_CURIOUS = PageId.STAY_CURIOUS_INTL_3,
  LONG_FOCUS = PageId.LONG_FOCUS_INTL_3,
  PERSONALIZE_TEST_FEEDBACK = PageId.PERSONALIZE_TEST_FEEDBACK_INTL_3,
  QUESTION_1 = PageId.QUESTION_1_INTL_3,
  QUESTION_2 = PageId.QUESTION_2_INTL_3,
  QUESTION_3 = PageId.QUESTION_3_INTL_3,
  QUESTION_4 = PageId.QUESTION_4_INTL_3,
  SPEED_FEEDBACK = PageId.SPEED_FEEDBACK_INTL_3,
  QUESTION_5 = PageId.QUESTION_5_INTL_3,
  QUESTION_6 = PageId.QUESTION_6_INTL_3,
  QUESTION_7 = PageId.QUESTION_7_INTL_3,
  QUESTION_8 = PageId.QUESTION_8_INTL_3,
  QUESTION_9 = PageId.QUESTION_9_INTL_3,
  QUESTION_10 = PageId.QUESTION_10_INTL_3,
  QUESTION_11 = PageId.QUESTION_11_INTL_3,
  QUESTION_12 = PageId.QUESTION_12_INTL_3,
  SMARTNESS_FEEDBACK = PageId.SMARTNESS_FEEDBACK_INTL_3,
  QUESTION_13 = PageId.QUESTION_13_INTL_3,
  QUESTION_14 = PageId.QUESTION_14_INTL_3,
  QUESTION_15 = PageId.QUESTION_15_INTL_3,
  QUESTION_16 = PageId.QUESTION_16_INTL_3,
  QUESTION_17 = PageId.QUESTION_17_INTL_3,
  QUESTION_18 = PageId.QUESTION_18_INTL_3,
  QUESTION_19 = PageId.QUESTION_19_INTL_3,
  QUESTION_20 = PageId.QUESTION_20_INTL_3,
  LOGICAL_SKILLS_FEEDBACK = PageId.LOGICAL_SKILLS_FEEDBACK_INTL_3,
  QUESTION_21 = PageId.QUESTION_21_INTL_3,
  QUESTION_22 = PageId.QUESTION_22_INTL_3,
  QUESTION_23 = PageId.QUESTION_23_INTL_3,
  QUESTION_24 = PageId.QUESTION_24_INTL_3,
  QUESTION_25 = PageId.QUESTION_25_INTL_3,
  AGE_QUESTION = PageId.AGE_QUESTION_INTL_3,
  EDUCATION_QUESTION = PageId.EDUCATION_QUESTION_INTL_3,
  DISCOVER_FEEDBACKS = PageId.DISCOVER_FEEDBACKS_INTL_3,
  PREPARE_FLOW = PageId.PREPARE_FLOW_INTL_3,
  EMAIL = PageId.EMAIL_INTL_3,
  OFFER = PageId.OFFER_INTL_3,
  SPECIAL_DISCOUNT = PageId.SPECIAL_DISCOUNT_INTL_3,
  CANCEL_OFFER = PageId.CANCEL_OFFER_INTL_3,
  PAYMENT = PageId.PAYMENT_INTL_3,
  REGISTRATION = PageId.REGISTRATION_INTL_3,
  NAME_ENTRY = PageId.NAME_ENTRY_INTL_3,
  CERTIFICATE = PageId.CERTIFICATE_INTL_3,
  REPORT = PageId.REPORT_INTL_3,
}
